import { updateItemInCollection } from "directus/src/operations";

export async function updateCurrency({ item, currencyId }) {
  try {
    const data = await updateItemInCollection("currencies", currencyId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
